import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Produto, CartItem } from '../tamas-models';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { AlertaPremiumDialog } from '../alerta-premium';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { summaryFileName } from '../../../node_modules/@angular/compiler/src/aot/util';

@Component({
  selector: 'app-shop-carrinho',
  templateUrl: './shop-carrinho.component.html',
  styleUrls: ['./shop-carrinho.component.css']
})
export class ShopCarrinhoComponent implements OnInit {
  hideCL: boolean = false;
  arrMeuProduto: Produto[];
  itemProduto: Produto = new Produto;
  meuCarrinho: CartItem[];
  fullCart: any[] = [];
  usuarioPremium: boolean = false;
  valorSubTotal: any = 0;
  valorSubTotalP: any = 0;
  valorTotalPedido: any = 0;
  valorTotalPedidoP: any = 0;
  diferencaP: any = 0;
  taxaEntrega: any = 0;
  tipoPedido: any = '';
  urlECfoto: any = '';
  arrProdQty: any[] = [];
  arrLojasF: any[] = [];
  //taxaFrete: any = 0;
  taxaEntregaVIP: any = 0;
  prazoEntrega: any = '';
  permiteRetirada: boolean = false;
  prazoRetirada: any = '';
  enderecoRetirada: any = '';
  avoidP: boolean = true;
  hideCrown: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }


  ngOnInit() {
    this.hideCL = true;
    console.log(this.tmaService.shopCarrinho);
    console.log(this.tmaService.shopCartFull);
    if (this.tmaService.shopCartFull.length == 0) {
      //consultamos a localstorage
      if (localStorage.getItem("tmsCarrinho") !== null) {
        this.tmaService.shopCartFull = JSON.parse(localStorage.getItem('tmsCarrinho'));
        this.urlECfoto = this.tmaService.urlRepositorioS3 + "/ecommerce/products/";
        this.fullCart = this.tmaService.shopCartFull;
        this.usuarioPremium = this.tmaService.hcPremium;
       

        this.getQtyProd();

        
      }
      else {
        //this.tmaService.shopQtyF = 0;
        this.voltar();
      }
      
    }
    else {
      this.urlECfoto = this.tmaService.urlRepositorioS3 + "/ecommerce/products/";
      //this.meuCarrinho = this.tmaService.shopCarrinho;
      this.fullCart = this.tmaService.shopCartFull;
      this.usuarioPremium = this.tmaService.hcPremium;
      this.getQtyProd();
    }

    if(this.tmaService.shopTipoFrete != ''){
      this.tipoPedido = this.tmaService.shopTipoFrete;
    }
    else{
      this.tipoPedido = 'entrega';
    }

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' && !this.tmaService.hcPremium || this.tmaService.hcWA && this.tmaService.hcSO == 'android' && !this.tmaService.hcPremium){
      this.avoidP = true;
    }
    else{
        this.avoidP = false;
    }

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' || this.tmaService.hcWA && this.tmaService.hcSO == 'android' ){
      this.hideCrown = true;
    }
    
  }

  getQtyProd() :void{
    //qtd disponível de cada produto e qtd maxima 
    var arrLj = [];
    this.fullCart.forEach(element => {
      var arrPiL = [];
      element.arrProdutos.forEach(prd => {
        arrPiL.push({ idProduto : prd.idProduto});
      });
      arrLj.push({ idLoja: element.idLoja, arrProdutos: arrPiL, cartUF: element.cartUF, cartCidade: element.cartCidade  });
    });

    console.log(arrLj);
    var arrLjFormat = JSON.stringify(arrLj);
    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      dadosProdutos: arrLjFormat
    };

    this.hideCL = false;
    this.tmaService.checkProdQty(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.arrProdQty = qRes['infoProd'];
        this.arrLojasF = qRes['iFrete'];
        //this.calcularPrecoPedido();
        this.checkyQtyAll();
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Ocorreu um erro ao obter informações dos produtos. Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }

  checkFreteAll() : void{
    var qtdDias = 0;
    var qtdDiasR = 0;
    this.fullCart.forEach(element => {
      //frete por loja
      var infoFL = this.arrLojasF.find(x => x.idLoja == element.idLoja);
      if(infoFL != undefined){

        //verificar questoes de retirada

        if(infoFL.retirada){
          //permite
          this.permiteRetirada = true;
          //this.prazoRetirada = infoFL.prazoretirada;
          qtdDiasR = infoFL.prazoretirada;

          //pensar nessa questão quando tiver mais de 1 loja na msm cidade
          this.enderecoRetirada = infoFL.local;
        }
        else{
          this.permiteRetirada = false;
        }
        if(infoFL.prazoentrega >= qtdDias){
          //se prazo era menor que da loja atual, aumentamos o prazo
          qtdDias = infoFL.prazoentrega;
        }
        if(infoFL.txgratis){
          //observar condições de compra minima;
          var valorCL = 0;
          var valorCLVIP = 0;

          
          // if(qtdDias == 0){
          //   qtdDias = infoFL.txfrete;
          // }
          // else{
          //   if(qtdDias <= infoFL.txfrete){
          //     //se prazo era menor que da loja atual, aumentamos o prazo
          //     qtdDias = infoFL.txfrete;
          //   }
          // }
          
          element.arrProdutos.forEach(prd => {
            valorCL += prd.prodPreco * prd.qtdProduto;
            valorCLVIP += prd.prodPrecoPremium & prd.qtdProduto;
          });
          if(valorCL >= infoFL.minimoFG && valorCLVIP >= infoFL.minimoFG){
            //valor consumido acima do minimo, então não acrescenta frente para este caso

          }
          else{
            this.taxaEntrega += infoFL.txfrete;
            this.taxaEntregaVIP += infoFL.txfretevip;  
          }
        }
        else{
         
          this.taxaEntrega += infoFL.txfrete;
          this.taxaEntregaVIP += infoFL.txfretevip;
        }
      }
    });
    this.prazoRetirada = 'Retirar após <b>' + qtdDiasR + '</b> dias'
    this.prazoEntrega = 'Entrega em até <b>' + qtdDias + '</b> dias úteis';
    this.calcularPrecoPedido();
  }

  checkyQtyAll() : void{
    this.fullCart.forEach((element, ljidx) => {
      element.arrProdutos.forEach((prd, idx) => {
        //find na qty
        var prdInfo = this.arrProdQty.find(x => x.idLoja == element.idLoja && x.idProduto == prd.idProduto);
        if(prdInfo != null){
          if(prdInfo.qtyD == 0){
            //indisponivel - remove
            console.log("produto removido qty zerada");
            console.log(idx);
            var idxAtual = idx;
            element.arrProdutos.splice(idx, 1);
            //element.splice
          }
          else{
            //não está zerado - verifica qtd atual comparado a qtd no carrinho
            if(prdInfo.qtyD < prd.qtdProduto){
              //less
              if(prdInfo.qtyD >= prdInfo.qtyM){
                prd.qtdProduto = prdInfo.qtyM;
              }
              else{
                //qtyD enough
                prd.qtdProduto = prdInfo.qtyD;
              }
            }
            else{
              //qtyD ok, check qtyM (needed?)
              
            }
          }
        }
      });
      //check if arrProdutos empty
      if(element.arrProdutos.length == 0){
        this.fullCart.splice(ljidx, 1);
        //element.splice(ljidx, 1);
      }
    });
    //agora sim verifica o frete e depois o valor dos produtos
    this.checkFreteAll();
  }

  checkQtyProd(idLoja: any, idPrd: any, qtyR: any) : boolean{
    var verifyQty = this.arrProdQty.find(x => x.idLoja == idLoja && x.idProduto == idPrd);
    console.log(verifyQty);
    if(verifyQty.qtyD >= qtyR +1){
      if(verifyQty.qtyM >= qtyR +1){
        console.log("qty liberada");
        return true;
      }
      else{
        console.log("qty max atingida");
        return false;
      }
    }
    else{
      console.log("qty disp atingida");
      return false;
    }
  }


  excluirIC() :void{
    console.log("call ic");
    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha
    };
    this.tmaService.zerarICart(customParams).subscribe();
  }

  decrease(meuindice: any, qLoja: any, indiceLoja: any): void {
    console.log(this.meuCarrinho);
    console.log(meuindice);
    //ez mode
    // if(this.meuCarrinho[meuindice].qtdProduto == 1){
    //     //criar alerta avisando que irá remover o produto
    //     console.log("Irá remover o produto!");

    //     const dialogRefConf = this.dialog.open(AlertaConfirmDialog, {
    //         width: '300px',
    //         data: {tituloAlerta: "Aviso", textoAlerta: "Deseja remover <b>" + this.meuCarrinho[meuindice].nomeProduto + "</b> do carrinho?", textoCancel: "Não", textoConfirm: "Sim"}
    //       });

    //       dialogRefConf.afterClosed().subscribe(result => {
    //         console.log('The dialog was closed');
    //         console.log(result);
    //         if (result == true){
    //             this.meuCarrinho.splice(meuindice, 1);
    //             this.tmaService.shopCarrinho = this.meuCarrinho;
    //             localStorage.setItem('myCart', JSON.stringify(this.tmaService.shopCarrinho));
    //             if(this.tmaService.shopCarrinho.length == 0){
    //                 console.log("remover cart storage");
    //                 localStorage.removeItem('myCart');
    //                 this.router.navigate(['/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade]);
    //             }
    //             else{
    //                 this.calcularPrecoPedido();
    //             }
    //         }
    //       });

    // }
    // else{
    //     //apenas remove 1
    //     console.log("decrease 1")
    //     this.meuCarrinho[meuindice].qtdProduto = this.meuCarrinho[meuindice].qtdProduto -1;
    //     this.tmaService.shopCarrinho = this.meuCarrinho;
    //     localStorage.setItem('myCart', JSON.stringify(this.tmaService.shopCarrinho));
    //     this.calcularPrecoPedido();
    // }
    //luciano mode
    if (this.fullCart[indiceLoja].arrProdutos[meuindice].qtdProduto == 1) {
      //criar alerta avisando que irá remover o produto
      console.log("Irá remover o produto!");

      const dialogRefConf = this.dialog.open(AlertaConfirmDialog, {
        width: '300px',
        data: { tituloAlerta: "Aviso", textoAlerta: "Deseja remover <b>" + this.fullCart[indiceLoja].arrProdutos[meuindice].nomeProduto + "</b> do carrinho?", textoCancel: "Não", textoConfirm: "Sim" }
      });

      dialogRefConf.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        console.log(result);
        if (result == true) {
          //this.meuCarrinho.splice(meuindice, 1);
          this.fullCart[indiceLoja].arrProdutos.splice(meuindice, 1);
          //check if arrProdutos empty
          if(this.fullCart[indiceLoja].arrProdutos.length == 0){
            this.fullCart.splice(indiceLoja, 1);
          }
          this.tmaService.shopCartFull = this.fullCart;
          localStorage.setItem('tmsCarrinho', JSON.stringify(this.tmaService.shopCartFull));
          if (this.tmaService.shopCartFull.length == 0) {
            console.log("remover cart storage");
            localStorage.removeItem('tmsCarrinho');
            this.excluirIC();
            this.router.navigate(['/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade]);
          }
          else {
            this.calcularPrecoPedido();
          }
        }
      });

    }
    else {
      //apenas remove 1
      console.log("decrease 1")
      //this.meuCarrinho[meuindice].qtdProduto = this.meuCarrinho[meuindice].qtdProduto -1;
      this.fullCart[indiceLoja].arrProdutos[meuindice].qtdProduto = this.fullCart[indiceLoja].arrProdutos[meuindice].qtdProduto - 1;
      this.tmaService.shopCartFull = this.fullCart;
      localStorage.setItem('tmsCarrinho', JSON.stringify(this.tmaService.shopCartFull));
      this.calcularPrecoPedido();
    }

  }

  increase(meuindice: any, qLoja: any, indiceLoja: any, qProduto: any): void {
    //ez mode
    // this.meuCarrinho[meuindice].qtdProduto++;
    // this.tmaService.shopCarrinho = this.meuCarrinho;
    // localStorage.setItem('myCart', JSON.stringify(this.tmaService.shopCarrinho));
    // this.calcularPrecoPedido();

    //luciano mode
    //var produtosLojaIndex = this.fullCart.findIndex(x => x.idLoja == qLoja);

    //qty first
    console.log("check qty", qLoja, qProduto);
    if(this.checkQtyProd(qLoja,qProduto, this.fullCart[indiceLoja].arrProdutos[meuindice].qtdProduto) == true){
      //liberado
      this.fullCart[indiceLoja].arrProdutos[meuindice].qtdProduto++;
      this.tmaService.shopCartFull = this.fullCart;
      console.log(this.tmaService.shopCartFull);
      localStorage.setItem('tmsCarrinho', JSON.stringify(this.tmaService.shopCartFull));
      // this.meuCarrinho[meuindice].qtdProduto++;
      // this.tmaService.shopCarrinho = this.meuCarrinho;
      // localStorage.setItem('myCart', JSON.stringify(this.tmaService.shopCarrinho));
      this.calcularPrecoPedido();
    }
    else{
      if(this.fullCart[indiceLoja].arrProdutos[meuindice].qtdProduto == 1){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta:  "Limite de Estoque",  textoAlerta: "Desculpe, só temos uma unidade diponível para este produto", iconAlerta: 'warning' }
        })
      }
      else{
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta:  "Limite de Estoque", textoAlerta: "A quantidade máxima disponível para este produto é de <b>" + this.fullCart[indiceLoja].arrProdutos[meuindice].qtdProduto + "</b> unidades", iconAlerta: 'warning' }
        })
      }
    }

  }

  calcularPrecoPedido(): void {
    //calcular o preço de cada produto e o valor final
    //ACERTAR ESSA PARTE PARA MULTILOJAS
    var soma = 0;
    var somaP = 0;

    this.fullCart.forEach(qLoja =>{
      qLoja.arrProdutos.forEach(item => {
        soma += item.prodPreco * item.qtdProduto;
        somaP += item.prodPrecoPremium * item.qtdProduto;
      });
    })

    // this.meuCarrinho.forEach(item => {
    //   soma += item.prodPreco * item.qtdProduto;
    //   somaP += item.prodPrecoPremium * item.qtdProduto;

    // });

    if (this.tipoPedido == 'entrega') {
      this.valorSubTotal = soma;
      this.valorSubTotalP = somaP;
      this.valorTotalPedido = soma + this.taxaEntrega;
      this.valorTotalPedidoP = somaP + this.taxaEntregaVIP;

    }
    else {
      this.valorTotalPedido = soma;
      this.valorTotalPedidoP = somaP;
      this.valorSubTotal = soma;
      this.valorSubTotalP = somaP;
    }
    var qDif = this.valorTotalPedido - this.valorTotalPedidoP;
    var difpercentual = this.valorTotalPedido / qDif;
    this.diferencaP = 100 / difpercentual;
    this.diferencaP = this.diferencaP.toFixed();


    if(this.usuarioPremium){
      this.tmaService.shopValorTotal = this.valorTotalPedidoP;
    }
    else{
      this.tmaService.shopValorTotal = this.valorTotalPedido;
    }

  }

  //alerta premium
  showVAP(): void {
    const alertaInfoPremium = this.dialog.open(AlertaPremiumDialog, {
      //width: '300px',
      data: { origem: "shopping" }
    });
    alertaInfoPremium.afterClosed().subscribe(result => {
      console.log(result);
      if (result == 1) {
        //saber mais
        this.router.navigate(['/premium']);
      }
      if (result == 2) {
        //assinar
        this.router.navigate(['/premium']);
      }
    });
  }


  radioTE(tipoEntrega: any): void {
    this.tipoPedido = tipoEntrega;
    console.log(tipoEntrega);
    this.calcularPrecoPedido();
  }

  showVP(): void {
    //já é premium, mostre pra ele a vantagem

  }

  goEndereco(): void {
    this.tmaService.shopCheck = true;
    this.tmaService.shopTipoFrete = this.tipoPedido;
    if(this.tipoPedido == "retirada"){
      this.router.navigate(['/shopping/checkout']);
    }
    else{
      this.router.navigate(['/shopping/endereco']);
    }
    
  }

  voltar(): void {
    //this._location.back();
    if (this.tmaService.shopUF == '') {
      this.router.navigate(['pre-shop/uf']);
    }
    else {
      this.router.navigate(['/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade]);
    }

  }
}
